import { propsCallback } from "./blueprint";
export function mapProps(propsMapper) {
    return {
        instanceCallbacks: [
            propsCallback(function (props) { return (propsMapper(props)); }),
        ],
    };
}
export default mapProps;

//# sourceMappingURL=mapProps.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/mapProps.js
// module id = 4
// module chunks = 0